export default __webpack_public_path__ + "static/media/19.e58aa501.jpg";